import { render, staticRenderFns } from "./status-form-field.vue?vue&type=template&id=01d5122f&scoped=true"
import script from "./status-form-field.vue?vue&type=script&lang=js"
export * from "./status-form-field.vue?vue&type=script&lang=js"
import style0 from "./status-form-field.vue?vue&type=style&index=0&id=01d5122f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d5122f",
  null
  
)

export default component.exports